import { submit, isValid, untouch } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { has } from 'lodash';

import * as VendorLinkIntegrationSelectors from 'Pages/vendorlinkintegration/state/selectors';
import * as VendorLinkIntegrationActions from 'Pages/vendorlinkintegration/state/actions';
import { VendorLinkFieldEnum } from 'Common/Constants/SISIntegration';
import { getLanguages } from 'Pages/importstudents/state/selectors';
import * as DialogActions from 'Components/dialogs/state/actions';
import { VENDORLINK_PREVIEW_FORM_NAME } from 'Common/FormEnum';
import { makeOptionsDataWithEmpty } from 'Common/FormHelper';
import { VendorLinkPreview } from './VendorLinkPreview';
import { getGrades, getSites } from 'State/selectors';
import { Main } from 'Containers/';
import {
  errorToast,
  successToast,
  toastType,
  createToast,
} from 'Common/ToastHelper';

export class VendorLinkPreviewStepContainer extends Component {
  static stepInfo = {
    icon: 'info',
    title: 'Preview',
    description: 'Confirm the data is mapped correctly.',
  };

  state = {};

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const {
      untouch,
      previewData,
      stepCompleted,
      previewErrors,
      previewSuccess,
      clearStudentId,
      previewBeenRun,
      setStepCompleted,
      clearPreviewErrors,
      clearPreviewSuccess,
      updatePreviewHasBeenRun,
      clearStudentImportErrors,
      setSingleStudentImportSuccess,
    } = this.props;

    // Preview
    if (previewSuccess && previewData) {
      createToast(
        toastType.success,
        'Success',
        'Preview Loaded Successfully',
        true
      );

      updatePreviewHasBeenRun(true);
      clearPreviewSuccess();
    }

    if (previewBeenRun && !prevProps.previewBeenRun) {
      if (!stepCompleted) {
        setStepCompleted(true);
      }
    } else if (!previewBeenRun && prevProps.previewBeenRun) {
      if (stepCompleted) {
        setStepCompleted(false);
      }
    }

    if (
      errorToast(
        this.props,
        prevProps,
        'previewErrors',
        'Preview Did Not Load Successfully'
      )
    ) {
      clearPreviewErrors();
    }

    if (
      !previewData &&
      !previewErrors &&
      previewSuccess &&
      !prevProps.previewSuccess
    ) {
      createToast(
        toastType.warning,
        'Student Not Found',
        'Please verify the student number is correct',
        true
      );

      clearPreviewSuccess();
    }

    // Single Student Import
    if (
      successToast(
        this.props,
        prevProps,
        'singleImportSuccess',
        'Student Imported. Check Import Log for Errors'
      )
    ) {
      clearStudentId();
      setSingleStudentImportSuccess(false);
      untouch(VENDORLINK_PREVIEW_FORM_NAME, VendorLinkFieldEnum.StudentId);
    }
    if (errorToast(this.props, prevProps, 'singleImportErrors')) {
      clearStudentImportErrors();
    }
  }

  getMainProps = () => {
    const {
      previewLoading,
      previewBeenRun,
      isPreviewValid,
      singleImportLoading,
      previewStudentId,
      clearPreviewData,
      setPreviewStudentId,

      stepCompleted,
      goToPreviousStep,
      goToNextStep,
    } = this.props;

    const mainProps = {
      toolbox: {
        shown: true,
        backButtonProps: {
          shown: true,
          disabled: previewLoading || singleImportLoading,
          callback: goToPreviousStep,
        },
        rightButtons: [
          {
            content: 'Preview',
            loading: previewLoading,
            disabled: previewLoading || singleImportLoading || !isPreviewValid,
            onClick: () => this.handleGetPreviewSubmit(previewStudentId),
          },
          {
            content: 'Import',
            loading: singleImportLoading,
            disabled:
              previewLoading ||
              singleImportLoading ||
              !isPreviewValid ||
              !previewBeenRun,
            onClick: async () => {
              if (await this.isMappedDataCorrect()) {
                this.handlePreviewSubmit(previewStudentId);
                clearPreviewData();
                setPreviewStudentId('');
              }
            },
          },
          {
            content: 'Next',
            disabled:
              !stepCompleted ||
              previewLoading ||
              singleImportLoading ||
              !previewBeenRun,
            onClick: goToNextStep,
          },
        ],
      },
    };

    return mainProps;
  };

  /** Called after user does a preview, then clicks "Import" */
  handlePreviewSubmit = studentId => this.props.importSingleStudent(studentId);

  handlePreviewIdChange = e => {
    if (has(e, 'target.value')) {
      this.props.setPreviewStudentId(e.target.value);
    }
  };

  /** Called when you click "Preview" for a single student import */
  handleGetPreviewSubmit = studentId => {
    const { getPreview } = this.props;

    // this.props.submit(VENDORLINK_PREVIEW_FORM_NAME);
    getPreview(studentId);
  };

  /** Generates the "Are you sure?" pop up */
  isMappedDataCorrect = () => {
    const { isComplete, setYesNoDialogProps } = this.props;

    if (isComplete) {
      return true;
    }

    return new Promise(resolve => {
      setYesNoDialogProps({
        showDialog: true,
        title: 'Continue',
        question:
          'Have you checked the data in the preview and ensured that it is mapped correctly?',
        yesCallback: () => resolve(true),
        noCallback: () => resolve(false),
        cancelCallback: () => resolve(false),
      });
    });
  };

  /** Called when you press ENTER in the Student Id Box in the Preview Page */
  handleKeyDown = e => {
    if (e.key === 'Enter') {
      this.handleGetPreviewSubmit(this.props.previewStudentId);
    }
  };

  render() {
    const {
      previewData,
      siteOptions,
      gradeOptions,
      languageOptions,
      getMappingsResult,
      previewLoading,
      singleImportLoading,
    } = this.props;

    const mainProps = this.getMainProps();

    return (
      <Main {...mainProps}>
        <VendorLinkPreview
          data={previewData}
          siteOptions={siteOptions}
          gradeOptions={gradeOptions}
          languageOptions={languageOptions}
          config={getMappingsResult}
          onChange={this.handlePreviewIdChange}
          onSubmit={() => this.handlePreviewSubmit}
          loading={previewLoading || singleImportLoading}
          handleKeyDown={this.handleKeyDown}
        />
      </Main>
    );
  }
}

const mapStateToProps = state => {
  return {
    getMappingsResult: VendorLinkIntegrationSelectors.getMappingsResult(state),

    // Preview Selectors
    previewData: VendorLinkIntegrationSelectors.getPreviewData(state),
    previewErrors: VendorLinkIntegrationSelectors.getPreviewErrors(state),
    previewSuccess: VendorLinkIntegrationSelectors.getPreviewSuccess(state),
    previewLoading: VendorLinkIntegrationSelectors.getPreviewLoading(state),
    previewBeenRun: VendorLinkIntegrationSelectors.getPreviewBeenRun(state),
    previewStudentId: VendorLinkIntegrationSelectors.getPreviewStudentId(state),

    // Single Student Import Selectors
    singleImportSuccess: VendorLinkIntegrationSelectors.getSingleImportSuccess(
      state
    ),
    singleImportLoading: VendorLinkIntegrationSelectors.getSingleImportLoading(
      state
    ),
    singleImportErrors: VendorLinkIntegrationSelectors.getSingleImportErrors(
      state
    ),
    singleImportData: VendorLinkIntegrationSelectors.getSingleImportData(state),

    // Others
    gradeOptions: makeOptionsDataWithEmpty(getGrades(state)),
    siteOptions: makeOptionsDataWithEmpty(
      getSites(state).filter(s => s.IsActive && s.IsLicensed),
      true
    ),
    languageOptions: makeOptionsDataWithEmpty(getLanguages(state)),

    isPreviewValid: isValid(VENDORLINK_PREVIEW_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  // Preview
  getPreview: VendorLinkIntegrationActions.getStudentPreview,
  clearStudentId: VendorLinkIntegrationActions.clearStudentId,
  clearPreviewData: VendorLinkIntegrationActions.clearPreviewData,
  clearPreviewErrors: VendorLinkIntegrationActions.clearPreviewErrors,
  clearPreviewSuccess: VendorLinkIntegrationActions.clearPreviewSuccess,
  setPreviewStudentId: VendorLinkIntegrationActions.setPreviewStudentId,
  updatePreviwSuccess: VendorLinkIntegrationActions.updatePreviewSuccess,
  updatePreviewHasBeenRun: VendorLinkIntegrationActions.updatePreviewHasBeenRun,

  // Single Student Import
  clearStudentImportErrors:
    VendorLinkIntegrationActions.clearStudentImportErrors,
  setSingleStudentImportSuccess:
    VendorLinkIntegrationActions.setSingleStudentImportSuccess,
  importSingleStudent: VendorLinkIntegrationActions.importStudent,

  // Other
  submit,
  setYesNoDialogProps: DialogActions.setYesNoDialogProps,
  untouch,
};

export const VendorLinkPreviewStep = connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLinkPreviewStepContainer);



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkPreviewStep/VendorLinkPreviewStep.js